"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createValidation = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = require("react");
var _jsonSchemaValidatorCatalyticWeb = _interopRequireDefault(require("@catalytic/json-schema-validator-catalytic-web"));
// Ajv types copied from https://github.com/flow-typed/flow-typed/blob/master/definitions/npm/ajv_v6.x.x/flow_v0.75.x-/ajv_v6.x.x.js
/*:: import { type JSONSchema } from '@catalytic/json-schema-validator-catalytic-web';

// Ajv types copied from https://github.com/flow-typed/flow-typed/blob/master/definitions/npm/ajv_v6.x.x/flow_v0.75.x-/ajv_v6.x.x.js*/
/*:: type $npm$ajv$ComparisonParams = {|
  comparison: string,
  limit: number | string,
  exclusive: boolean
|};*/
/*:: type $npm$ajv$DependenciesParams = {|
  property: string,
  missingProperty: string,
  depsCount: number,
  deps: string
|};*/
/*:: type AjvErrorObject = {
  dataPath: string,
  keyword: string,
  schemaPath: string,
  params:
    | {| ref: string |} // RefParams
    | {| limit: number |} // LimitParams
    | {| additionalProperty: string |} // AdditionalPropertiesParams
    | $npm$ajv$DependenciesParams // DependenciesParams
    | {| format: string |} // FormatParams
    | $npm$ajv$ComparisonParams // ComparisonParams
    | {| multipleOf: number |} // MultipleOfParams
    | {| pattern: string |} // PatternParams
    | {| missingProperty: string |} // RequiredParams
    | {| type: string |} // TypeParams
    | {| i: number, j: number |} // UniqueItemsParams
    | {| keyword: string |} // CustomParams
    | {| missingPattern: string |} // PatternRequiredParams
    | {| propertyName: string |} // PropertyNamesParams
    | {| failingKeyword: string |} // IfParams
    | {| caseIndex: number |} // SwitchParams
    | {} // NoParams
    | {| allowedValues: Array<mixed> |}, // EnumParams
  propertyName?: string,
  message?: string,
  schema?: mixed,
  parentSchema?: JSONSchema<>,
  data?: mixed
};*/
/*:: export type ValidationErrors = Array<AjvErrorObject> | null | void;*/
/*:: export type Validation = {
  errors: ValidationErrors,
  isValidSchema: boolean,
  schemaError: string | void
};*/
/*:: export type ValidationType = {
  schema: JSONSchema<>,
  value?: any
};*/
/*:: type Compiled = {
  schemaError?: string,
  validator?: Function
};*/
// Compiling a schema is the expensive half of validating against one, and the
// caller that matters does it in a loop: `viewHelpers.validate` runs on every
// render of every cell, so a grid of seven columns and twenty visible rows
// compiles the same seven schemas a hundred and forty times over. Compiled
// validators are cached against the schema object itself, which turns that
// into seven.
//
// Keyed by reference and held weakly: a schema that goes out of scope takes
// its validator with it, and a *new* schema object compiles again — so a
// caller that rebuilds its schemas is no worse off than before and can never
// be served a stale answer. The one thing this does not survive is a schema
// mutated in place after it has been compiled; the mutations this codebase
// does (`hidden` and `readOnly`, in `TableFieldV2`) do not affect validation.
var compiledSchemas /*: WeakMap<Object, Compiled>*/ = new WeakMap();
var compileSchema = function compileSchema(schema /*: JSONSchema<>*/) /*: Compiled*/{
  var ajv = (0, _jsonSchemaValidatorCatalyticWeb.default)();
  try {
    return {
      validator: ajv.compile(schema)
    };
  } catch (e) {
    if (process.env.NODE_ENV !== 'test') {
      console.error(e);
    }
    return {
      schemaError: e.message
    };
  }
};
var createValidation = exports.createValidation = function createValidation(_ref /*:: */) /*: Validation*/{
  var schema = _ref /*:: */.schema,
    value = _ref /*:: */.value;
  var cacheable = schema !== null && (0, _typeof2.default)(schema) === 'object';
  var compiled = cacheable ? compiledSchemas.get(schema) : undefined;
  if (!compiled) {
    compiled = compileSchema(schema);
    if (cacheable) {
      compiledSchemas.set(schema, compiled);
    }
  }
  var _compiled = compiled,
    schemaError = _compiled.schemaError,
    validator = _compiled.validator;

  // `validator` may throw an Error when evaluating invalid Expression syntax
  // See packages/json-schema-validator/lib/createJSONSchemaValidator.ts
  try {
    // Coercion of nullable empty string
    // https://github.com/epoberezkin/ajv/issues/919
    if (typeof validator === 'function') {
      validator((schema === null || schema === void 0 ? void 0 : schema.nullable) === false && value === '' ? null : value);
    }
  } catch (e) {}
  var isValidSchema = typeof validator === 'function';
  var errors = typeof validator === 'function' ? validator.errors : undefined;
  return {
    errors: errors,
    isValidSchema: isValidSchema,
    schemaError: schemaError
  };
};
var useValidation = function useValidation(_ref2 /*:: */) {
  var schema = _ref2 /*:: */.schema,
    value = _ref2 /*:: */.value;
  return /*: Validation*/(0, _react.useMemo)(function () {
    return createValidation({
      schema: schema,
      value: value
    });
  }, [schema, value]);
};
var _default = exports.default = useValidation;
//# sourceMappingURL=useValidation.js.map